import * as React from "react";
import { SVGProps } from "react";
const SvgDebtManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={24} height={24} rx={4} fill="#095921" />
    <path
      d="M18 8.2v7.2c0 .33-.117.613-.352.848a1.157 1.157 0 0 1-.848.352H7.2c-.33 0-.612-.117-.847-.352A1.156 1.156 0 0 1 6 15.4V8.2c0-.33.118-.612.353-.847S6.87 7 7.2 7h9.6c.33 0 .613.118.848.353S18 7.87 18 8.2ZM7.2 9.4h9.6V8.2H7.2v1.2Zm0 2.4v3.6h9.6v-3.6H7.2Z"
      fill="#fff"
    />
  </svg>
);
export default SvgDebtManagement;
